<template>
  <v-app>
    <!-- <div style="margin-top: -6vh;"> -->
      <!-- <div class="edops-nav d-flex align-items-center">
        <div class="edops-groups-item d-flex">
          <router-link to="/edops/staff/hasil-edops">
            <div class="edops-item d-flex">
              <span class="svg-icon svg-icon-xl svg-icon-primary edops-icon" :class="checkActive('hasil-edops', 'edops-result', 'edops-result-detail')">
                <inline-svg src="media/svg/icons/General/Settings-2.svg" />
              </span>
              <span class="edops-text" :class="checkActive('hasil-edops', 'edops-result', 'edops-result-detail')">Hasil EDOPS</span>
            </div>
          </router-link>
          <router-link to="/edops/staff/pertanyaan">
            <div class="edops-item d-flex">
              <span class="svg-icon svg-icon-xl svg-icon-primary edops-icon" :class="checkActive('edopsStaffPertanyaan')">
                <inline-svg src="media/svg/icons/General/User.svg" />
              </span>
              <span class="edops-text" :class="checkActive('edopsStaffPertanyaan')">Pertanyaan Evaluasi Pendidikan</span>
            </div>
          </router-link>
          <router-link to="/edops/staff/hasilevaluasi">
            <div class="edops-item d-flex">
              <span class="svg-icon svg-icon-xl svg-icon-primary edops-icon"
                :class="checkActive('edopsRekap', 'edopsStaffhasilevaluasi')">
                <inline-svg src=" media/svg/icons/General/Folder.svg" />
              </span>
              <span class="edops-text" :class="checkActive('edopsRekap', 'edopsStaffhasilevaluasi')">Hasil Evaluasi Pendidikan</span>
            </div>
          </router-link>
        </div>
      </div> -->
      <router-view></router-view>
    <!-- </div> -->
  </v-app>
</template>

<style lang="scss">
@import "~vuetify/dist/vuetify.css";

.theme--light.v-application {
  background: transparent !important;
}

.v-application code {
  box-shadow: none !important;
}
</style>

<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      url: ''
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.url = this.$router.currentRoute
    this.config.subheader.display = true
  },
  updated() {
    this.url = this.$router.currentRoute
  },
  methods: {
    checkActive(path, childPath = null) {
      if (childPath !== null) {
        if (this.url.name == path || this.url.name == childPath) {
          return "active";
        }
      } else {
        return this.url.name == path ? "active" : "";
      }
    }
  }
}
</script>